module.exports = __webpack_public_path__ + "img/ico_casino_popup_freetry@3x.3787e943.png";